import { render } from "./NewValidationPage.vue?vue&type=template&id=f778d926"
import script from "./NewValidationPage.vue?vue&type=script&lang=js"
export * from "./NewValidationPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__